import React, { Fragment } from 'react';
import map from 'lodash/map';
import Bem from 'bemHelper';
import { numDescOnlyText } from 'helpers/numDesc';
import beautifyNumber from 'helpers/beautifyNumber';
import { Thumb } from 'components/image';
import Row, { Col } from 'components/row';
import Link from 'components/link';

import linksBild from 'src-sites/bild/links';
import { renderSimpleLink, getHousesCounter } from 'src-sites/bild/section-project/render-common';

const bemClasses = new Bem('project');

export default function blockCreators(creators) {
  if (!creators || !creators[0]) return null;

  return (
    <div {...bemClasses('creators')}>
      {renderCreatorsListHorizontal.call(this, creators)}
    </div>
  );
}

function renderCreatorsListHorizontal(valCreator) {
  const { i18n } = this;

  return map(valCreator, (it, index) => {
    const image = (typeof it.avatar === 'string' || !it.avatar) ? { id: it.avatar } : it.avatar;
    let name = it.name ? it.name : null;
    const housesCounter = getHousesCounter(it.living_complex_counters);
    const minBuiltYear = housesCounter.ready_house_from_year ? i18n('developerYear', { placeholder: housesCounter.ready_house_from_year }) : '';
    if (!name && it.name) name = it.name;

    return (
      <Fragment key={index}>
        {name && it.url &&
          <div {...bemClasses('creator')}>
            <Row {...bemClasses('content')} alignIcenter>
              <Col {...bemClasses('col', 'img')} allAuto allPr={0}>
                <div {...bemClasses('imgContainer')}>
                  <div {...bemClasses('img')}>
                    <Link
                      {...bemClasses('link', 'fill')}
                      builder={linksBild.sectionLanding}
                      builderProps={it}
                      noRedirector
                      blank
                    >
                      <span />
                    </Link>
                    <Thumb
                      {...bemClasses('imgPic')}
                      image={image}
                    />
                  </div>
                </div>
              </Col>
              <Col {...bemClasses('col', 'topicPhonesBuildBuilt')} allPr={0}>
                <Row {...bemClasses('row', 'topicPhonesBuildBuilt')} allColumn alignIcenter>
                  <Col {...bemClasses('col', 'topicPhones')} allPr={0}>
                    <div {...bemClasses('topicContainer')}>
                      {renderSimpleLink(
                        bemClasses,
                        {
                          builder: linksBild.sectionLanding,
                          builderProps: it,
                          text: name,
                          noRedirector: true,
                          blank: true
                        },
                        false,
                        { topic: true },
                        false
                      )}
                    </div>
                  </Col>
                  <Col {...bemClasses('col', 'buildBuilt')} allPr={0}>
                    <div {...bemClasses('buildContainer')}>
                      <span {...bemClasses('text')}>
                        <span {...bemClasses('text', 'bold')} children={beautifyNumber(housesCounter.in_progress_house_number || 0)} />
                        {`\u00a0${
                          numDescOnlyText(
                            housesCounter.in_progress_house_number || 0,
                            i18n('developerHouse'),
                            i18n('developerHouseDeclination'),
                            i18n('developerHouseMultiple')
                          )
                        } ${i18n('developerBuild')} ${
                          i18n('developerInCount', { placeholder: housesCounter.in_progress_house_in_lc_number || 0 })
                        }`}
                      </span>
                    </div>
                    <div {...bemClasses('builtContainer')}>
                      <span {...bemClasses('text')}>
                        <span {...bemClasses('text', 'bold')} children={beautifyNumber(housesCounter.ready_house_number || 0)} />
                        {`\u00a0${
                          numDescOnlyText(
                            housesCounter.ready_house_number || 0,
                            i18n('developerHouseReady'),
                            i18n('developerHouseReadyDeclination'),
                            i18n('developerHouseReadyMultiple')
                          )
                        } в\u00a0${housesCounter.ready_house_in_lc_number || 0}\u00a0ЖК${minBuiltYear}`}
                      </span>
                    </div>
                    {+it.rel_finished_cottage_towns > 0 &&
                      <div {...bemClasses('builtContainer')}>
                        <span {...bemClasses('text')}>
                          <span
                            {...bemClasses('text', 'bold')}
                            children={beautifyNumber(+it.rel_finished_cottage_towns || 0)}
                          />
                          {`\u00a0${
                            numDescOnlyText(
                              +it.rel_finished_cottage_towns || 0,
                              i18n('developerHouseReadyCT'),
                              i18n('developerHouseReadyCTDeclination'),
                              i18n('developerHouseReadyCTMultiple')
                            )
                          }`}
                        </span>
                      </div>
                    }
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        }
      </Fragment>
    );
  });
}
